<template>
    <div
        class="downloads-filterbar"
        role="search"
        aria-label="Downloads filtern und durchsuchen"
        v-if="showTypeFilter || showPlantLocationFilter || showSearch"
    >
        <div v-if="showTypeFilter">
            <label for="type" class="form-label"> Dokumententyp </label>
            <select
                id="type"
                v-model="localSelectedType"
                class="form-select"
                aria-label="Dokumententyp auswählen"
                @change="updateType"
            >
                <option value="">Alle anzeigen</option>
                <option v-for="type in types" :key="type" :value="type">
                    {{ type }}
                </option>
            </select>
        </div>

        <div v-if="showPlantLocationFilter">
            <label for="plantLocation" class="form-label">Werk</label>
            <select
                id="plantLocation"
                v-model="localSelectedPlantLocation"
                class="form-select"
                aria-label="Werk auswählen"
                @change="updatePlantLocation"
            >
                <option value="">Alle anzeigen</option>
                <option
                    v-for="plantLocation in plantLocations"
                    :key="plantLocation"
                    :value="plantLocation"
                >
                    {{ plantLocation }}
                </option>
            </select>
        </div>

        <div v-if="showSearch" class="downloads-filterbar__search">
            <label for="search" class="form-label">Dokument suchen</label>
            <input
                id="search"
                v-model="localSearchQuery"
                type="search"
                class="form-control"
                placeholder="Suchbegriff eingeben..."
                aria-label="Dokument durchsuchen"
                autocomplete="off"
                @input="updateSearchQuery"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'FilterBar',
    props: {
        types: {
            type: Array,
            required: true,
        },
        plantLocations: {
            type: Array,
            required: true,
        },
        searchQuery: {
            type: String,
            default: '',
        },
        selectedType: {
            type: String,
            default: '',
        },
        selectedPlantLocation: {
            type: String,
            default: '',
        },
        showTypeFilter: {
            type: Boolean,
            default: true,
        },
        showPlantLocationFilter: {
            type: Boolean,
            default: true,
        },
        documentCount: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        showSearch() {
            return this.documentCount > 3;
        },
    },
    data() {
        return {
            localSearchQuery: this.searchQuery,
            localSelectedType: this.selectedType,
            localSelectedPlantLocation: this.selectedPlantLocation,
        };
    },
    watch: {
        searchQuery(newVal) {
            this.localSearchQuery = newVal;
        },
        selectedType(newVal) {
            this.localSelectedType = newVal;
        },
        selectedPlantLocation(newVal) {
            this.localSelectedPlantLocation = newVal;
        },
    },
    methods: {
        updateSearchQuery() {
            this.$emit('update:search-query', this.localSearchQuery);
        },
        updateType() {
            this.$emit('update:selected-type', this.localSelectedType);
        },
        updatePlantLocation() {
            this.$emit(
                'update:selected-plantLocation',
                this.localSelectedPlantLocation
            );
        },
    },
};
</script>
